import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaAndroid, FaApple, FaTimes } from 'react-icons/fa';

const slideDown = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`;

const BannerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(90deg, #1F467E 0%, #3a6ba8 100%);
  color: white;
  z-index: 999999;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  padding: 8px 12px;
  animation: ${slideDown} 0.5s ease-out;
`;

const BannerContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 500;
`;

const IconWrapper = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;
`;

const AppName = styled.span`
  font-weight: 700;
  font-size: 14px;
`;

const ActionButton = styled.a`
  background-color: white;
  color: #1F467E;
  border: none;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 12px;
  text-decoration: none;
  margin-left: auto;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
    background-color: #f8f9fa;
    color: #1F467E;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  padding: 4px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  &:hover {
    color: white;
  }
`;

const IOS_LINK = "https://apps.apple.com/br/app/locasmartpro-app-locador/id6757645086";
const ANDROID_LINK = "https://play.google.com/store/apps/details?id=com.locasmartpro.gestaodelocadorasapplocadores&pcampaignid=web_share";

export function MobileAppBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [platform, setPlatform] = useState<'ios' | 'android' | null>(null);

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      
      // Check if previously dismissed in this session
      if (sessionStorage.getItem('mobileAppBannerDismissed')) {
        return;
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
        setPlatform('ios');
        setIsVisible(true);
      } else if (/android/i.test(userAgent)) {
        setPlatform('android');
        setIsVisible(true);
      }
    };

    checkMobile();
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('mobileAppBannerDismissed', 'true');
  };

  if (!isVisible || !platform) return null;

  return (
    <BannerContainer>
      <IconWrapper>
        {platform === 'ios' ? <FaApple size={20} /> : <FaAndroid size={20} />}
      </IconWrapper>
      
      <BannerContent>
        <TextContainer>
          <AppName>LocaSmart Pro</AppName>
          <span>Baixe nosso App</span>
        </TextContainer>
      </BannerContent>

      <ActionButton 
        href={platform === 'ios' ? IOS_LINK : ANDROID_LINK} 
        target="_blank" 
        rel="noopener noreferrer"
      >
        BAIXAR
      </ActionButton>

      <CloseButton onClick={handleClose}>
        <FaTimes size={14} />
      </CloseButton>
    </BannerContainer>
  );
}
